// extracted by mini-css-extract-plugin
export var option = "_51-1";
export var optionActive = "_51-2";
export var pill = "_51-0";